var _line, _line2, _line3, _line4, _line5, _line6, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg62B0B19B83B282277E15A7AfEatRepeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 75.1562,
    y1: 8.26419e-8,
    x2: 75.1562,
    y2: 150,
    stroke: "#03514E",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 112.388,
    y1: 11.0482,
    x2: 37.3883,
    y2: 140.952,
    stroke: "#03514E",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 139.271,
    y1: 39.2635,
    x2: 9.3667,
    y2: 114.264,
    stroke: "#03514E",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 150.5,
    y1: 77.0315,
    x2: 0.5,
    y2: 77.0315,
    stroke: "#03514E",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 139.452,
    y1: 114.264,
    x2: 9.54834,
    y2: 39.2635,
    stroke: "#03514E",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 111.268,
    y1: 140.983,
    x2: 36.2679,
    y2: 11.0796,
    stroke: "#03514E",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 75,
    r: 66.7969,
    fill: "#FFFDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7266 54.25H33.7288L33.7266 56.2478L33.6572 118.699C33.656 119.762 34.0781 120.782 34.8303 121.533L36.2437 120.118L34.8303 121.533L38.3498 125.049C39.0999 125.798 40.1166 126.219 41.1767 126.219H109.745C110.793 126.219 111.798 125.808 112.546 125.075L116.144 121.548C116.911 120.795 117.344 119.766 117.344 118.691V56.25V54.25H115.344H35.7266Z",
    fill: "white",
    stroke: "#03514E",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.507 34.3281L115.506 34.3281L35.4816 34.3632C35.4814 34.3632 35.4811 34.3632 35.4809 34.3632C33.0366 34.3636 31.3125 36.4618 31.3125 38.7122V56.25V58.25H33.3125H117.688H119.688V56.25V38.6772C119.688 36.4193 117.956 34.3281 115.507 34.3281Z",
    fill: "#85E5C6",
    stroke: "#03514E",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6562 51.5625H115.344",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 112.5C88.4442 112.5 98.9375 102.007 98.9375 89.0625C98.9375 76.1183 88.4442 65.625 75.5 65.625C62.5558 65.625 52.0625 76.1183 52.0625 89.0625C52.0625 102.007 62.5558 112.5 75.5 112.5Z",
    fill: "#85E5C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.293 88.2422L73.0742 96.0234L87.0078 82.1016",
    stroke: "#03514E",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.758 123.633L35.6562 119.531H115.344L111.242 123.633C110.867 124.008 110.358 124.219 109.828 124.219H41.1722C40.6417 124.219 40.133 124.008 39.758 123.633Z",
    fill: "#F76F00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2344 27.7812C53.2344 26.6767 54.1298 25.7812 55.2344 25.7812H60.6094C61.7139 25.7812 62.6094 26.6767 62.6094 27.7812V39.8438H53.2344V27.7812Z",
    fill: "white",
    stroke: "#03514E",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7344 27.7812C90.7344 26.6767 91.6298 25.7812 92.7344 25.7812H98.1094C99.2139 25.7812 100.109 26.6767 100.109 27.7812V39.8438H90.7344V27.7812Z",
    fill: "white",
    stroke: "#03514E",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg62B0B19B83B282277E15A7AfEatRepeat);
export default __webpack_public_path__ + "static/media/62b0b19b83b282277e15a7af_eat-repeat.891dbd14df826dab1f8579dde4bb11bc.svg";
export { ForwardRef as ReactComponent };